import { render, staticRenderFns } from "./NivelTecnologicoList.vue?vue&type=template&id=053789a8&scoped=true"
import script from "./NivelTecnologicoList.vue?vue&type=script&lang=js"
export * from "./NivelTecnologicoList.vue?vue&type=script&lang=js"
import style0 from "./NivelTecnologicoList.vue?vue&type=style&index=0&id=053789a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053789a8",
  null
  
)

export default component.exports